<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" class="bg-0A1129">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="background-size: cover; margin: auto;">
                                <CRow>
                                    <CCol sm="6">
                                    <CCard class="position-relative overflow-hidden text-white" :style="{
        backgroundImage: `url(${backgroundUrlBanner})`,
        backgroundSize: 'cover',
        borderRadius: '32px',
        height: '650px', // Make sure height is set!
        position: 'relative', // Important for absolute child
        border:'none'
      }" style="border:none">
                                        <div class="p-4" style="z-index: 3;">
                                            <h3 class="mb-4" style="font-size: 32px; font-weight: 600;">
                                                Get the best education directly from the experts
                                            </h3>
                                        </div>
    
                                        <!-- This will now stick to the bottom of the card -->
                                        <div class="d-flex align-items-center text-white" style="
                                                position: absolute;
                                                bottom: 20px;
                                                left: 20px;
                                                right:20px;
                                                border-radius: 24px;
                                                background: rgba(10, 17, 41, 0.8);
                                                backdrop-filter: blur(1.5px);
                                                padding: 12px 16px;
                                                z-index: 4;
                                                ">
                                            <img src="https://randomuser.me/api/portraits/women/44.jpg" class="rounded-circle" width="32" height="32" alt="avatar" />
                                            <div class="ml-3">
                                                <div style="font-weight: bold;">Join with 32k+ students!</div>
                                                <small>Come see the stories of our successful students</small>
                                            </div>
                                        </div>
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <h3 class="custom-30px-500 text-white mt-5">
                                       Log In
                                            
                                            <h4 class="custom-18px-400 text-white text-left mt-3">Email</h4>
                                            <div style="position: relative; display: inline-block; width: 100%;">
                                                <img
                                                    src="../assets/img/flyhigh/sms.png"
                                                    alt="User Icon"
                                                    style="
                                                    position: absolute;
                                                    left: 12px;
                                                    top: 50%;
                                                    transform: translateY(-50%);
                                                    width: 20px;
                                                    height: 20px;
                                                    pointer-events: none;
                                                    "
                                                />
                                                <input
                                                    type="text"
                                                    class="custom-bg-blue-black pl-5"
                                                    style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px"
                                                    placeholder="Enter your Email"
                                                    v-model="Email"
                                                />
                                            </div>


                                            <h4 class="custom-18px-400 text-white text-left mt-3">Password</h4>
                                            <div style="position: relative; display: inline-block; width: 100%;">
                                                <img
                                                    src="../assets/img/flyhigh/eye.png"
                                                    alt="User Icon"
                                                    style="
                                                    position: absolute;
                                                    left: 12px;
                                                    top: 50%;
                                                    transform: translateY(-50%);
                                                    width: 20px;
                                                    height: 20px;
                                                    pointer-events: none;
                                                    "
                                                />
                                                <input
                                                    type="password"
                                                    class="custom-bg-blue-black pl-5"
                                                    style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px"
                                                    placeholder="Enter your Password"
                                                    v-model="Password"
                                                />
                                            </div>
                                            <div>
                                                <input type="radio" /><label class="custom-16px-400 ml-3">Remember Me</label>
                                            </div>
                                            <CAlert v-if="Error" class="mt-3" color="danger">
                                               <h5> {{ Message || messageBox }}</h5>
                                                </CAlert>
                                            <CRow>
                                                <CButton class="bg-1796FD border-16px p-3 text-white mt-4" block @click.prevent="trylogin">Sign In</CButton>
                                            </CRow>
                                            <h3 class="custom-16px-400 text-white text-center mt-3">Does not have an account<label class="font-color-1796FD ml-3" @click="GoToSignUp()">? Register </label></h3>
                                            <CRow>
                                                <CButton type="button" class="border-16px p-3 text-white text-center mt-4" block style="background:rgba(255, 255, 255, 0.04);border: 1px solid #4F4F4F;"><img src="../assets/img/flyhigh/google.png" width="20px" class="mr-2"/>Log in with Google</CButton>
                                            </CRow>
                                           

                                      
                                    </h3>
                                </CCol>
                                </CRow>
                               
                            </CCol>
    
    
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrlBanner from "../assets/img/light.png";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrlBanner,

            isActive: false,



            Email: "",
            Password: "",



          
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            userEmail: "",
            userPassword: "",


            Error: false,
            Message: "",

            lblGoogle: "Google",

        };
    },
    created() {
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },


    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },

        trylogin() {
            this.Error = false;

            const formData = new FormData();

            if (this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("Email", this.Email.toLowerCase());
                formData.append("Password", this.Password);

                this.$API
                    .post(this.$LoginTokenWeb, formData, { withCredentials: true })
                    .then((response) => {
                    const msg = response.data.message;

                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.messageBox = msg;
                        this.messageColor = "danger";
                        this.Error = true;
                    } else if (response.status === 200) {
                        this.messageBox = msg;
                        this.messageColor = "success";

                        if (response.data.status !== 400) {
                            const target = this.$route.query.targetUrl;
if (target) {
  this.$router.push(target);
} else {
    this.$router.push("index");
}
                        } else {
                        this.Loading = false;
                        this.messageBox = msg;
                        this.messageColor = "danger";
                        this.Error = true;
                        }
                    }
                    })
                    .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.messageBox = error.response?.data?.message || "Unexpected error.";
                    this.messageColor = "danger";
                    });
            }
        },
        registerAccount() {

            const formData = new FormData();

            if (this.Name === "" || this.Email === "" || this.Phone === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.selectedUser);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);




                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Dashboard");
        },
        async login() {
            this.lblGoogle = "Google";
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());



                
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    var authResponse = googleuser.getAuthResponse();
            var accessToken = authResponse.access_token;
            var idToken = authResponse.id_token;

            console.log('ID Token:', idToken);
            console.log('Access Token:', accessToken);

            // Verify if the token includes the scope
            await this.verifyScopes(accessToken);

            // Fetch user phone and address info
            const userInfo = await this.getUserInfo(accessToken);
            console.log('User Info:', userInfo);

            const userName = userInfo.displayName;
                    this.getUserEmail(idToken, userName);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async verifyScopes(accessToken) {
            try {
                const response = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${accessToken}`);
                const tokenInfo = await response.json();

                console.log('Token Info:', tokenInfo);

                if (tokenInfo.scope.includes('https://www.googleapis.com/auth/user.phonenumbers.read')) {
                    console.log('Scope is present in the token.');
                } else {
                    console.error('Scope is missing in the token.');
                }
            } catch (error) {
                console.error('Error verifying scopes:', error);
            }
        },
async getUserInfo(accessToken) {
    try {
        const response = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,addresses,emailAddresses,names', {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        const userData = await response.json();
        
        console.log('User Data:', userData);

        const phoneNumber = userData.phoneNumbers?.length > 0 ? userData.phoneNumbers[0].value : 'No phone number available';
        const country = userData.addresses?.length > 0 ? userData.addresses[0].country : 'No country information available';
        const displayName = userData.names?.length > 0 ? userData.names[0].displayName : 'No display name available';

        return { phoneNumber, country, displayName };
    } catch (error) {
        console.error('Error fetching user info:', error);
        return { phoneNumber: 'Error', country: 'Error' };
    }
},
        async getUserEmail(idToken, username) {
            this.lblGoogle = "Google";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSession(idToken, this.user, username);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async SetSession(idToken, user, username) {
            this.lblGoogle = "Processing";
            console.log("username:" + username)
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response);
                if (response.status === 202) {

                //this.$router.push("JoinUs?email=" + this.user);
               this.registerAccountGoogleUser(user,username, idToken);
           
               this.SetSession(idToken, user, username);
            

                } else if (response.status === 200) {
                    this.lblGoogle = "Processing";
                    const userData = response.data;
                    console.log("User Data:", userData);
                    const userType = response.data.data.userType;
                    console.log("User Type:", response.data.data.userType);
                    await this.delay(5000);
                    //this.$router.push("Profile");
                    const isAuth = await this.UserAuth();
            if (isAuth) {
                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                  
                                    //  const userId = response.data.data.userType;
                                    // console.log("userid", userId);
                                    if (response.data.data.userType === '-') {
                                        this.$router.push("Profile");
                                    } else if (response.data.data.userType === 'individual') {
                                        this.$router.push("Profile");
                                    } else {
                                        this.$router.push("Dashboard");
                                    }

                                }
            } else {
                this.lblGoogle = "Google";
                this.GoToLogin();
            }
                    
                    console.error("Failed to fetch user information:", response);
                } else {
                    this.lblGoogle = "Google";
                    // Handle other status codes
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
},
        OpenForgot()
        {
            this.$router.push("ForgotPassword");
        },
        GoToSignUp() {
            const eventCode = this.$route.query.eventCode;

            if (eventCode) {
                this.$router.push({ name: "JoinUs", query: { eventCode } });
            } else {
                this.$router.push({ name: "JoinUs" });
            }
        },
        registerAccountGoogleUser(user,username, idtoken) {

const formData = new FormData();
    formData.append("name", username);
    formData.append("email", user);
    formData.append("userType", 'individual');
    const eventCode = this.$route.query.eventCode;
    if (eventCode) {
        formData.append("eventCode", eventCode);
    }

    



    this.$API
        .post(this.$Register, formData, { withCredentials: true })
        .then((response) => {
            if (response.data.status === 400) {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;

            }
            if (response.status == 200) {

                alert('Please update your phone number on your profile');
               
                if (response.data.status !== 400) {

                    if (
                        this.$route.query.targetUrl != "" &&
                        (this.$route.query.targetUrl != null) &
                        (this.$route.query.targetUrl != undefined)
                    ) {
                        this.$router.push(this.$route.query.targetUrl);
                    } else {
                        this.$router.push("Profile");
                    }


                } else {
                    this.Loading = false;
                    this.Message = response.data.message;
                    this.Error = true;
                }
            } else {
                this.Loading = false;
                this.Error = true;
                this.Message = response.data.message;
            }
        })
        .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
        });
},
GoToSignUp()
{
    this.$router.push("SelectionTypeUser");
}


    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>